export default class FeedbackPopoverController {
  constructor(close, options, vdFeedbackService) {
    'ngInject'
    this.promptNegative = options.promptNegative
    this._close = close
    this._options = options
    this._vdFeedbackService = vdFeedbackService
  }

  send() {
    this._vdFeedbackService.saveAdditionalDetails({
      activity: this._options.activity,
      score: this._options.score,
      comments: this.details,
    })
    this._close()
  }
}
